(app => {

    app.filter("dataTableFilters",
        function () {
            const dataTableFilters = (rows, filters) => {
                let filteredRows = rows;

                if (!!filters) {
                    filters.forEach(filter => {
                        const selectedFilters = filter.options.filter(option => option.selected);

                        if (selectedFilters.length > 0) {
                            filteredRows = filteredRows.filter(row => {
                                const cell = row.cells[filter.index];

                                return !!cell && selectedFilters.some(selectedFilter => cell === selectedFilter.label);
                            });
                        }
                    });
                }

                return filteredRows;
            };

            return dataTableFilters;
        });

})(window.app);